// Generated by ts-to-zod
import { z } from 'zod';

export const requestExtensionPayloadSchema = z.object({
  email: z.string(),
  phone: z.string().optional(),
  extension: z.string(),
  message: z.string(),
});
